import axios from "axios";


// initialize axios 
const api = axios.create({
    baseURL: `${process.env.REACT_APP_API_BASE_URL}`,
    // headers: {
    //     common: { 'Authorization': `Bearer ${localStorage.getItem("accessToken") ?? ""}` }
    // },
    withCredentials: true,
});



export default api;
